module.exports = __webpack_public_path__ + "img/pp9.fd103492.png";